module.exports = __webpack_public_path__ + "img/hr-sand-rock-small-16.2bc684b7.png";